import React, { FC } from 'react';
import { Dropdown } from 'rsuite';
import { LOADING_FIELDS, LOADING_FIELDS_NAMES } from '../../../../constants/loading-modal/loading-form';
import { WhisperComponent } from '../../../developers/page-components/WhisperComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { getReportTemplate } from '../../../../store/disputes/actions/dispute-queues';
import { Title } from '../../../developers/page-components/Title';
import clsx from 'clsx';
import { ISelectorData } from '../../../application/NewApplication';

interface Props {
  formik: any;
  typesList: ISelectorData[];
}
export const ReportTypeDropdown: FC<Props> = (props) => {
  const { formik, typesList } = props;

  const downloadTemplate = async (typeValue: string, typeLabel: string): Promise<void> => {
    const provider = formik.values[LOADING_FIELDS.PROVIDERS];
    await getReportTemplate({ provider, type: typeValue, label: typeLabel });
  };

  const dropdownInput = (props, ref): JSX.Element => {

    const value = typesList?.find(el => el.value === formik.values[LOADING_FIELDS.TYPE])?.label;

    const title = (
      <div className="d-flex align-items-center">
        <span>{LOADING_FIELDS_NAMES.TYPE}</span>
        <span className="text-danger ms-1">*</span>
      </div>
    );

    return (
      <div className="input-container">
        <Title title={title} additionalClass="mb-1 fs-6 text-black" />
        <div
          {...props}
          ref={ref}
          className="form-control form-control-sm form-control-solid"
        >
          <div className="d-flex align-items-center justify-content-between">
						<span className={clsx('fc-text-overflow', !value && 'text-muted')}>
							{value ? value : 'Select type'}
						</span>

            <FontAwesomeIcon
              icon={faChevronDown}
              width={12}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="col-md-6 queue-dropdown">
      <Dropdown renderToggle={dropdownInput} placement="bottomEnd">
        {
          typesList?.map(({ label, value }) => (
            <Dropdown.Item
              key={value}
              onClick={(): any => formik.setFieldValue(LOADING_FIELDS.TYPE, value)}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="fc-text-overflow">{label}</span>
                <div
                  className="text-muted cursor-pointer ms-2"
                  onClick={(): Promise<void> => downloadTemplate(value, label)}
                >
                  <WhisperComponent
                    isTooltip
                    whisperText="Download report template"
                    placement="top"
                    mainText={
                      <FontAwesomeIcon
                        icon={faFileArrowDown}
                        width={12}
                      />
                    }
                  />
                </div>
              </div>
            </Dropdown.Item>
          ))
        }
      </Dropdown>
    </div>
  );
};